<script lang="ts">
  import { FileText } from "lucide-svelte";
  interface Props {
    monthlyUpdates: number;
    totalPages: number;
    t: (path: string) => string;
  }
  let { monthlyUpdates, totalPages, t }: Props = $props();
</script>

<div class="rounded-xl border bg-card p-4 shadow-sm flex flex-col justify-between">
  <div class="flex items-center justify-between">
    <p class="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t('dashboard.kpi.recent_updates')}</p>
    <FileText class="h-4 w-4 text-primary" />
  </div>
  <div class="mt-2 flex items-baseline gap-1">
    <span class="text-3xl font-extrabold tracking-tight">{monthlyUpdates}</span>
    <span class="text-xs text-muted-foreground">{t('dashboard.kpi.pages_unit')}</span>
  </div>
  <div class="mt-3 flex items-center justify-between text-xs text-muted-foreground border-t pt-2">
    <span>{t('dashboard.kpi.total_published')} <strong>{totalPages}</strong></span>
    <span>{t('dashboard.kpi.active_operation')}</span>
  </div>
</div>